export default function isOdd(number) {
  if (number % 2 === 0) {
    return false;
  } else {
    return true;
  }
}
